import React from 'react';
import { Box } from '@material-ui/core';

/**
 * Pills Block Component
 * Schematic representation of active filters
 */
const Pills = ({ maxPills = 15, theme, hidden, maxItems, ...props }) => {
  if (hidden) return null;
  const primaryColor = theme?.palette?.primary?.main || '#e0e0e0';
  const widths = [50, 75, 40, 65, 45, 70, 45];

  return (
    <Box width="100%" display="flex" flexWrap="wrap" gap={1} alignItems="flex-start" mb={0} {...props}>
      {Array.from({ length: parseInt(maxPills, 10) || 15 }).map((_, i) => (
        <Box
          // eslint-disable-next-line react/no-array-index-key
          key={`pill-${i}`}
          height={24}
          width={widths[i % widths.length]}
          bgcolor="#fff"
          border={`1px solid ${primaryColor}75`}
          borderRadius={12}
          display="flex"
          alignItems="center"
          justifyContent="center"
          mb={0.5} // Spacing for wrapped items
          mr={0.5}
        >
          <Box width="60%" height={6} bgcolor={`${primaryColor}15`} borderRadius={3} />
        </Box>
      ))}
    </Box>
  );
};

export default Pills;
